import React from "react";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import EventCard from "./EventCard";
// import { Item } from "./EventsCarousel";
import './stack-carousel.css';
import { DateTimeBadge, EventLikeButton } from "./event";
import { Link } from "react-router-dom";
import { formatTimeRange } from "../utils/common";
import EventArtistCaption from "./EventArtistsCaption";
import ImageWithSkeleton from "./ImageWithSkeleton";
import { getEventClub } from "../utils/eventClub";
import { getClubPath, getEventPath } from "../utils/clubPath";

export const Item = ({ item, isActive, height }) => {
   const club = getEventClub(item);
   const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
   const images_list = Array.isArray(item?.images) && item?.images?.length ? item.images : [];
   const hasMultipleImages = images_list.length > 1;
   
   const handlePrevImage = (e) => {
      e.stopPropagation();
      setCurrentImageIndex((prev) => (prev === 0 ? images_list.length - 1 : prev - 1));
   };
   
   const handleNextImage = (e) => {
      e.stopPropagation();
      setCurrentImageIndex((prev) => (prev === images_list.length - 1 ? 0 : prev + 1));
   };
   
   const currentImage = images_list[currentImageIndex]?.path;
   
   return (
      <>
         <div className="Carousel__Item" style={{ '--height': height, width: '100%', height: height, borderRadius: '10px', overflow: 'hidden', position: 'relative' }}>
            {/* Background Image */}
            <ImageWithSkeleton
               src={currentImage}
               alt={item.title || "event image"}
               className="carousel-image"
               wrapperClassName="carousel-image-wrapper"
               skeletonHeight={parseInt(height, 10) || 400}
               loading="lazy"
               imgStyle={{ width: '100%', borderRadius: '10px', overflow: 'hidden' }}
            />

            {hasMultipleImages && (
               <>
                  <button
                     onClick={handlePrevImage}
                     style={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        background: 'rgba(0,0,0,0.5)',
                        border: 'none',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        transition: 'background 0.3s'
                     }}
                     onMouseEnter={(e) => e.target.style.background = 'rgba(0,0,0,0.8)'}
                     onMouseLeave={(e) => e.target.style.background = 'rgba(0,0,0,0.5)'}
                  >
                     ❮
                  </button>
                  <button
                     onClick={handleNextImage}
                     style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        background: 'rgba(0,0,0,0.5)',
                        border: 'none',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        transition: 'background 0.3s'
                     }}
                     onMouseEnter={(e) => e.target.style.background = 'rgba(0,0,0,0.8)'}
                     onMouseLeave={(e) => e.target.style.background = 'rgba(0,0,0,0.5)'}
                  >
                     ❯
                  </button>
                  <div
                     style={{
                        position: 'absolute',
                        bottom: '15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: 'rgba(0,0,0,0.7)',
                        color: 'white',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        fontSize: '13px',
                        zIndex: 10,
                        fontWeight: '500'
                     }}
                  >
                     {currentImageIndex + 1} / {images_list.length}
                  </div>
               </>
            )}

            {/* Gradient Overlay */}
            <div className="carousel-overlay" />

            {/* Content */}
            {/* News Badge */}
            <div className='carousel-content__header'>
               <DateTimeBadge className={`carousel-badge ${isActive ? 'active' : 'inactive'}`} datetime={item.eventStartTime} />
               <EventLikeButton event={item} />
            </div>
            <div className={`carousel-content ${isActive ? 'active' : 'inactive'}`}>
               {/* Title and Button */}
               <div className="carousel-content-bottom">
                  <h3 className={`carousel-title ${isActive ? 'active' : 'inactive'}`}>
                     <Link to={getEventPath(item)}>
                        {item.title}
                     </Link>
                  </h3>
                  <EventArtistCaption artists={item.artists} />
                  <p className="text">
                     {formatTimeRange(item.eventStartTime, item.eventEndTime)}
                  </p>
                  <p className="card__addr text">
                     <Link className="font-bold" to={getClubPath(club)}>
                        <strong
                           className="font-weight-bold"
                           style={{ fontFamily: "Axiforma" }}
                        >
                           {club?.name}{" "}
                        </strong>
                        {[club?.locality || "", item.address?.city || club?.city || ""]
                           .filter((e) => e)
                           .join(", ")}
                     </Link>
                  </p>
               </div>
            </div>
         </div>
      </>
   )
}
export default function EventsGallery({ data }) {
  const ref = React.useRef();
  const slides = Array.isArray(data) ? data : [];

  if (!slides.length) return null;

  if (slides.length === 1) {
    return (
      <div className="EventsGallery" style={{ width: "100%", margin: '30px auto', display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: '750px', padding: '0 15px' }}>
          <Item height="400px" item={slides[0]} isActive={true} />
        </div>
      </div>
    );
  }

  // StackedCarousel requires at least (maxVisibleSlide + 1) / 2 items.
  const minItems = 3;
  const carouselData =
    slides.length > 0 && slides.length < minItems
      ? Array.from({ length: minItems }, (_, i) => slides[i % slides.length])
      : slides;

  return (
    <div className="EventsGallery" style={{ width: "100%", position: "relative", margin: '30px 0' }}>
      <ResponsiveContainer
        carouselRef={ref}

        render={(parentWidth, carouselRef) => {
          // If you want to use a ref to call the method of StackedCarousel, you cannot set the ref directly on the carousel component
          // This is because ResponsiveContainer will not render the carousel before its parent's width is determined
          // parentWidth is determined after your parent component mounts. Thus if you set the ref directly it will not work since the carousel is not rendered
          // Thus you need to pass your ref object to the ResponsiveContainer as the carouselRef prop and in your render function you will receive this ref object
          let currentVisibleSlide = 5;
          if (parentWidth <= 700) currentVisibleSlide = 3;
         //  if (parentWidth <= 1440) currentVisibleSlide = 5;
         //  if (parentWidth <= 1080) currentVisibleSlide = 1;
          return (
            <StackedCarousel
              ref={carouselRef}
              customScales={[1, 0.7, 0.5, 0.2]}
              slideComponent={(_props) => {
               const { dataIndex } = _props;
               const item = carouselData[dataIndex] ?? {};
               return (
                  <Item height={parentWidth <= 700 ? '270px': '400px'} item={item} />
               )
              }}
              slideWidth={parentWidth < 800 ? parentWidth - 40 : 750}
              carouselWidth={parentWidth}
              data={carouselData}
              currentVisibleSlide={currentVisibleSlide}
              maxVisibleSlide={5}
              useGrabCursor
            />
          );
        }}
      />
      <>
        <button
          style={{ position: "absolute", top: "40%", left: 10, zIndex: 10 }}
          className="btn--nav btn--prev"
          onClick={() => {
            ref.current?.goBack();
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" id="Chevron-Back-Circle-Sharp--Streamline-Ionic-Sharp" ><desc>{"\n    Chevron Back Circle Sharp Streamline Icon: https://streamlinehq.com\n  "}</desc><path fill="currentColor" d="M24 0.48C11.0108 0.48 0.48 11.0108 0.48 24S11.0108 47.52 24 47.52 47.52 36.9892 47.52 24 36.9892 0.48 24 0.48Zm7.0821 34.3754 -2.559 2.559L15.1087 24l13.4144 -13.4144 2.559 2.559L20.2267 24l10.8554 10.8554Z" strokeWidth={1} /></svg>

        </button>
        <button
          style={{ position: "absolute", top: "40%", right: 10, zIndex: 10 }}
          className="btn--nav btn--next"
          onClick={() => {
            ref.current?.goNext(6);
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" id="Chevron-Forward-Circle-Sharp--Streamline-Ionic-Sharp" ><desc>{"\n    Chevron Forward Circle Sharp Streamline Icon: https://streamlinehq.com\n  "}</desc><path fill="currentColor" d="M24 0.48C11.0109 0.48 0.48 11.0108 0.48 24S11.0109 47.52 24 47.52c12.9892 0 23.52 -10.5308 23.52 -23.52S36.9892 0.48 24 0.48Zm-4.5231 36.9344 -2.5589 -2.559L27.7734 24 16.918 13.1446l2.5589 -2.559L32.8912 24 19.4769 37.4144Z" strokeWidth={1} /></svg>

        </button>
      </>
    </div>
  );
}
